export * from "./MainHeading";